export const row = ({ theme: { colors } }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridColumnGap: '64px',
    textAlign: 'right',
    alignItems: 'center',
    padding: '15px 0 13px',
    borderBottom: `1px solid ${colors.blueGrey1}`,
});
